import { Component, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { MatSidenav } from '@angular/material/sidenav';
import { SidenavService } from '@ml/core/services';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { MediaObserver } from '@angular/flex-layout';

@Component({
  selector: 'ml-right-sidenav',
  template: `
    <mat-sidenav-container
      fxLayout="column"
      class="sidenav full-height full-width"
      (backdropClick)="onClose()"
    >
      <mat-sidenav
        [style.max-width]="(width$ | async) + '%'"
        class="full-width"
        #sidenav
        mode="over"
        position="end"
        autoFocus="false"
        [opened]="opened$ | async"
        (closed)="onClose()"
      >
        <div class="padding-16">
          <ng-template #sidenavContent></ng-template>
        </div>
      </mat-sidenav>

      <mat-sidenav-content fxLayout="column" class="full-height">
        <ng-content></ng-content>
      </mat-sidenav-content>
    </mat-sidenav-container>
  `,
  styleUrls: ['./right-sidenav.component.scss']
})
export class RightSidenavComponent implements OnInit {
  width$: Observable<number>;
  sidenavContent;
  opened$: Observable<boolean>;

  @ViewChild('sidenav', { static: true }) sidenav: MatSidenav;

  @ViewChild('sidenavContent', { read: ViewContainerRef, static: true })
  set _sidenavContent(value: ViewContainerRef) {
    this.sidenavService.sidenavContent = value;
  }

  constructor(
    private mediaObserver: MediaObserver,
    private sidenavService: SidenavService
  ) {}

  ngOnInit() {
    this.opened$ = this.sidenavService.opened$;
    this.width$ = this.sidenavService.width$.pipe(
      map(value => {
        return this.mediaObserver.isActive('lg') ? value : 100;
      })
    );
  }

  onClose() {
    this.sidenavService.close();
  }
}
